module.exports = __webpack_public_path__ + "img/theo-meditate.57875c0f.svg";